import './style.css'

export const Faq = () => {
  return(
    <>
    <header>
    <h1>faq</h1>
</header>

<div className="container">

    <h2>para quem é o comandos.dev?</h2>
    <p>se você está começando sua jornada como desenvolvedor ou mesmo se já tem experiência, o comandos.dev foi criado para ajudar a encontrar rapidamente o que você precisa. Sabemos que há uma enorme quantidade de ferramentas e sistemas diferentes, e é fácil se perder no meio de tanta informação. Por isso, nossa missão é reunir os comandos mais importantes, mantendo tudo simples e direto.</p>

    <h2>faltou algum comando?</h2>
    <p>é possível que você não encontre algum comando ou sistema que usa. Estamos em constante expansão para garantir que o maior número possível de informações úteis seja armazenado e disponibilizado para você.</p>

    <h2>sua colaboração é muito importante!</h2>
    <p>se tiver sugestões de melhorias ou quiser apoiar essa iniciativa, entre em contato com a gente. Seu feedback será fundamental para continuar aprimorando o comandos.dev e tornar a plataforma ainda mais útil para todos.</p>

</div>
    </>
  );
};